import { connect } from "react-redux";
import { RootState } from "app/rootReducer";
import { completeForgotPassword as onCompleteForgotPassword, showDialog, AuthDialog, forgotPassword as onForgotPassword } from "../reducer";
import ForgotPasswordDialog from "./ForgotPasswordDialog";

const mapStateToProps = (state: RootState) => ({
    error: state.auth.error,
    isLoading: state.auth.isLoading,
    showDialog: state.auth.showDialog === AuthDialog.ForgotPassword,
});

const mapDispatchToProps = {
    onClose: () => showDialog(AuthDialog.None),
    onCompleteForgotPassword,
    onForgotPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordDialog);
